export function membershipInstallment() {


    let paymentInstallment = document.getElementById('payment-installments') as HTMLInputElement | null;
    let installmentSection = document.getElementsByClassName('membership-renewal-installment-section')[0] as HTMLElement;

    if (paymentInstallment == null || installmentSection == undefined) return;

    paymentInstallment.addEventListener('click', function (e) {
        if (paymentInstallment.checked) {
            installmentSection.style.display = 'block';
        }
        else {
            installmentSection.style.display = 'none';

        }
    }, false);
}

